export let dataProps = {
    id: 0,
    rack_name: '',
    description: ''
}


// WEBPACK FOOTER //
// ./src/store/modules/inventoryRack/properties.js